/* tslint:disable */
/* eslint-disable */
/**
 * Pet Profile A Service
 * Pet Profile A Layer Service For more information or information on how this data maps to the kryios data see [here](https://chewyinc.atlassian.net/wiki/spaces/MPROD/pages/1957927091/Pet+Property+to+Data+Mapping)
 *
 * The version of the OpenAPI document: 1.0
 * Contact: DL-IT_Pet_Profile@chewy.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IntegerValueValidationModel
 */
export interface IntegerValueValidationModel {
    /**
     * 
     * @type {number}
     * @memberof IntegerValueValidationModel
     */
    min?: number;
    /**
     * 
     * @type {number}
     * @memberof IntegerValueValidationModel
     */
    max?: number;
}

/**
 * Check if a given object implements the IntegerValueValidationModel interface.
 */
export function instanceOfIntegerValueValidationModel(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function IntegerValueValidationModelFromJSON(json: any): IntegerValueValidationModel {
    return IntegerValueValidationModelFromJSONTyped(json, false);
}

export function IntegerValueValidationModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): IntegerValueValidationModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'min': !exists(json, 'min') ? undefined : json['min'],
        'max': !exists(json, 'max') ? undefined : json['max'],
    };
}

export function IntegerValueValidationModelToJSON(value?: IntegerValueValidationModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'min': value.min,
        'max': value.max,
    };
}

